import Tr from 'translations/Translations';

export const POSITION_TYPE = {
	TEXT: 'TEXT',
	YES_NO: 'YESNO',
}

export const POSITION_TYPE_LABEL = {
	[POSITION_TYPE.TEXT]: Tr('text'),
	[POSITION_TYPE.YES_NO]: Tr('yes')+'/'+Tr('no'),
}

const createItem = (key) => ({
	label: POSITION_TYPE_LABEL[key],
	value: key
})

export default [
	createItem(POSITION_TYPE.TEXT),
	createItem(POSITION_TYPE.YES_NO),
]